const BACKEND_URL = process.env.REACT_APP_API_URL || '';

export interface CompareRequest {
  yacht_ids: string[];
  date_from: string;
  date_to: string;
}

export async function fetchComparison(payload: CompareRequest): Promise<any[]> {
  const res = await fetch(`${BACKEND_URL}/yachts/compare/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Compare API error: ${res.status}`);
  const data = await res.json();
  return data.yachts || [];
}

export interface ResolvedLink {
  target_url: string;
  page_type?: string;
  payload?: any;
  expired?: boolean;
}

export async function resolveShareLink(code: string): Promise<ResolvedLink> {
  const res = await fetch(`${BACKEND_URL}/api/share/${code}/`);
  if (res.status === 410) return { target_url: '', expired: true };
  if (!res.ok) throw new Error('Link not found');
  return res.json();
}

export interface OgMeta {
  og_title?: string;
  og_description?: string;
  og_image?: string;
}

export interface ShareLinkResult {
  url: string;
  code: string;
}

export async function createShareLink(
  url: string,
  og?: OgMeta,
  pageType?: string,
  payload?: object,
  expiresAt?: string,
): Promise<ShareLinkResult> {
  const res = await fetch(`${BACKEND_URL}/api/share/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      url,
      ...og,
      page_type: pageType,
      payload,
      expires_at: expiresAt,
    }),
  });
  if (!res.ok) throw new Error(`Share API error: ${res.status}`);
  const data = await res.json();
  // Use current origin so the short link works on any environment (local, stage, prod)
  return {
    url: `${window.location.origin}/api/s/${data.code}`,
    code: data.code,
  };
}
